import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import {
  Typography,
  Button,
  Box,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import sh from "bundles/common/utils/sh";
import JobOfferList from "bundles/Candidate/components/JobOfferList";

const FourBlogJobOffers = () => {
  const theme = useTheme();
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const authenticityToken = useSelector((state) => state.authenticity_token);
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));

  const [jobOffers, setJobOffers] = useState([]);

  const handleOfferClicked = (offer) => {
    window.location.href = `/${i18nLocale}/job-offers/${offer.id}`;
  };

  const handleAllOffersClicked = (e) => {
    e.preventDefault();
    window.location.href = `/${i18nLocale}/candidate/job_offers`;
  };

  const fetchFourJobs = () => {
    sh.get("random_jobs", {
      params: {
        quantity: 4,
        authenticity_token: authenticityToken,
      },
    })
      .then((res) => {
        setJobOffers(res.data?.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    fetchFourJobs();
  }, []);

  return (
    <>
      <Box style={{ backgroundColor: "#F9FAFF" }}>
        <Box maxWidth={isDesktop ? "lg" : "90%"} style={{ margin: "auto" }}>
          <Typography
            variant="h2"
            style={{
              paddingTop: "36px",
              paddingBottom: "16px",
              fontSize: "36px",
              fontFamily: "Segoe UI Bold, system-ui, sans-serif",
              textAlign: "center",
            }}
          >
            <FormattedMessage id="landing_candidate.our_job_offers" />
          </Typography>
          <JobOfferList
            offers={jobOffers}
            handleOfferClick={handleOfferClicked}
            columnPerRow={isDesktop ? 2 : 1}
          />
        </Box>
        <Box style={{ textAlign: "center", marginBottom: "32px" }}>
          <Button
            variant="rounded"
            color="primaryContained"
            style={{ minWidth: "280px", fontFamily: "Segoe UI Semibold, sans-serif" }}
            onClick={handleAllOffersClicked}
          >
            <FormattedMessage id="landing_candidate.less_than_100_jobs" />
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default FourBlogJobOffers;
